<template>
    <div class="terraces-section" v-if="terracesArr != null" id="menu-link-terraces">
        <div class="container">
            <sectionTitle :options="[{ title : terracesArr.terraces_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: terracesArr.terraces_quote_img, title : terracesArr.terraces_quote_title, desc: terracesArr.terraces_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : terracesArr.terraces_desc_left, desc_right: terracesArr.terraces_desc_right}]"></sectionDescColumn>
            <terracesImagesGrid :options="[{ cards: terracesArr.terraces_card_new, grid_img : terracesArr.terraces_card_img}]"></terracesImagesGrid>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import terracesImagesGrid from '@/components/terraces/terraces-images-grid.vue'
    import {mapGetters} from 'vuex'

    export default {
        name: 'terraces-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            terracesArr: 'loadTerracesArr',
            // apartmentsArr: 'loadApartments',
            // salesCardPage: 'loadSalesCardPage',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            terracesImagesGrid,
            // svgIcon,
            // promoForm,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/terraces/terraces-section.scss';
    @import '@/styles/components/terraces/respond/terraces-section-respond.scss';
</style>